
import Api from "@/api/userService";
import ResultCodeType from "@/constant/ResultCodeType";
import routerName from "@/router/routerName";
import { message } from "ant-design-vue";
import { defineComponent, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute, useRouter } from "vue-router";

interface country_code_list {
  id: string;
  code: string;
  name: string;
}
interface allrole_list {
  id: string;
  name: string;
}
export default defineComponent({
  name: "UserCreate",
  setup() {
    const { t } = useI18n();
    const router = useRouter();
    const route = useRoute();
    const id = route.query.id as string;
    const isEdit = route.query.isEdit as string;
    const country_code_list = ref<Array<country_code_list>>();
    const allrole_list = ref<Array<allrole_list>>();
    const validatePhone = (rule: any, value: string) => {
      const reg_tel =
        /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      if (value && !reg_tel.test(value)) {
        return Promise.reject(t("incorrectformat"));
      }
      return Promise.resolve();
    };

    const rules = {
      phone: [
        { required: false, message: t("cannotbeempty") },
        { validator: validatePhone, trigger: "change" },
      ],
    };
    const language = ref([
      {
        label: "简体中文",
        value: "zh-cn",
      },
      {
        label: "EN",
        value: "en",
      },
      {
        label: "DE",
        value: "de",
      },
    ]);
    const agent_info = ref(
      JSON.parse(sessionStorage.getItem("agent_info") || "{}")
    );
    const costomerForm = ref({
      id: "",
      username: "",
      type: "2",
      phone: "",
      country_code: "+86",
      language: "",
      roles: {
        role_id: "",
        role_name: "",
      },
      duty_start: "00:00",
      duty_end: "00:00",
      remark: "",
      message_switch: false,
      org_ids: [],
    });
    const addUserF = () => {
      const params = {
        username: costomerForm.value.username.replace(/\s/g, ""),
        phone: costomerForm.value.phone,
        org_ids: JSON.stringify(costomerForm.value.org_ids),
        country_code: costomerForm.value.country_code,
        language: costomerForm.value.language,
        type: costomerForm.value.type,
        remark: costomerForm.value.remark,
        agent_id: agent_info.value.agent_id,
        role_id: costomerForm.value.roles.role_id,
        message_switch: costomerForm.value.message_switch,
        duty_start: costomerForm.value.duty_start,
        duty_end: costomerForm.value.duty_end,
      };
      if (params.username.length > 50) {
        message.error(t("fillinyournamecorrectly"));
      } else {
        Api.addOrgUser(params).then((val: any) => {
          if (val.err_no == ResultCodeType.success_200) {
            message.success(t("createdsuccessfully"));
            cancel();
          } else {
            message.error(val.err_msg);
          }
        });
      }
    };
    const editUserF = () => {
      const params = {
        user_id: id,
        username: costomerForm.value.username.replace(/\s/g, ""),
        phone: costomerForm.value.phone,
        org_ids: JSON.stringify(costomerForm.value.org_ids),
        country_code: costomerForm.value.country_code,
        language: costomerForm.value.language,
        type: costomerForm.value.type,
        remark: costomerForm.value.remark,
        agent_id: agent_info.value.agent_id,
        role_id: costomerForm.value.roles.role_id,
        message_switch: costomerForm.value.message_switch,
        duty_start: costomerForm.value.duty_start,
        duty_end: costomerForm.value.duty_end,
      };
      Api.editOrgUser(params).then((val: any) => {
        if (val.err_no == ResultCodeType.success_200) {
          message.success(t("submittedsuccessfully"));
          cancel();
        } else {
          message.error(val.err_msg);
        }
      });
    };

    const onSubmit = () => {
      if (isEdit) {
        editUserF();
      } else {
        addUserF();
      }
    };
    const getuserdetailF = () => {
      const params = {
        user_id: id,
      };
      Api.getOrgUserDetails(params).then((val: any) => {
        costomerForm.value.id = val.result.id;
        costomerForm.value.username = val.result.username;
        costomerForm.value.phone = val.result.phone;
        costomerForm.value.org_ids = val.result.org_ids;
        costomerForm.value.country_code = val.result.country_code;
        costomerForm.value.language = val.result.language;
        costomerForm.value.type = val.result.type;
        costomerForm.value.remark = val.result.remark;
        costomerForm.value.roles = val.result.roles;
        if (costomerForm.value.roles.role_id) {
          costomerForm.value.roles.role_id = String(
            costomerForm.value.roles.role_id
          );
        }
        costomerForm.value.message_switch = val.result.message_switch;
        costomerForm.value.duty_start = val.result.duty_start;
        costomerForm.value.duty_end = val.result.duty_end;
      });
    };
    const getCountryCode = () => {
      Api.getCountry().then((res) => {
        if (res.err_no == ResultCodeType.success_200) {
          country_code_list.value = res.result;
        } else {
          message.error(res.err_msg);
        }
      });
    };
    const getAllRolesList = () => {
      Api.getAllRolesList().then((res) => {
        if (res.err_no == ResultCodeType.success_200) {
          allrole_list.value = res.result;
        } else {
          message.error(res.err_msg);
        }
      });
    };
    const org_user_list = ref();
    const getOrgUserList = () => {
      const param = sessionStorage.getItem("username") || "";
      Api.getOrgUserList(param).then((res: any) => {
        org_user_list.value = res.result;
      });
    };
    const filterOption = (input: any, option: any) => {
      if (option.label) {
        return option.label.indexOf(input.toLowerCase()) >= 0;
      } else {
        return false;
      }
    };
    const cancel = () => {
      router.go(-1);
    };
    const labelCol = { style: { "min-width": "120px", "text-align": "left" } };
    onMounted(() => {
      getCountryCode();
      getAllRolesList();
      getOrgUserList();
      if (id) {
        getuserdetailF();
      }
    });
    return {
      costomerForm,
      country_code_list,
      allrole_list,
      rules,
      onSubmit,
      cancel,
      language,
      agent_info,
      org_user_list,
      filterOption,
      isEdit,
      labelCol,
      routerName,
      t,
    };
  },
});
